import useUninstallApp from './hooks/useUninstallApp.ts'
import { Typography } from '@mui/material'
import UninstallAppForm from './UninstallAppForm.tsx'
import useUninstallAppForm from './hooks/useUninstallAppForm.ts'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { uninstallFormschema } from '../../types/UninstallForm.ts'
import ActionModal from '../../../../../core/components/modal/ActionModal.tsx'
import Modal from '@/core/components/modal/Modal.tsx'

const UninstallAppModal = () => {
  const { isOpen, closeModal } = useUninstallApp()
  const form = useForm({
    resolver: zodResolver(uninstallFormschema),
    defaultValues: {
      imei: '',
      registersNumber: '',
      brand: '',
      model: ''
    }
  })

  const {
    handlerConfirm,
    closeConfirmDialog,
    confirmDialogOpen,
    handlerSearchDevice,
    onSubmit,
    searchingDevice,
    uninstallingDevice
  } = useUninstallAppForm(form)

  return (
    <Modal
      onClose={closeModal}
      open={isOpen}
      aria-labelledby="modal-modal-title"
      title="Desinstalar App"
    >
      <>
        <UninstallAppForm
          form={form}
          handlerSearchDevice={handlerSearchDevice}
          onSubmit={onSubmit}
          onCancel={closeModal}
          searchingDevice={searchingDevice}
        />
        <ActionModal
          title="¿Confirmar desinstalación?"
          maxWidth="320px"
          okBtnText="Confirmar"
          onOkAction={() => handlerConfirm(form.getValues('registersNumber'))}
          okBtnColor="primary"
          onCancelAction={closeConfirmDialog}
          isOkLoading={uninstallingDevice}
          body={
            <Typography variant="body2">
              Esto eliminará la aplicación y liberará el dispositivo. Esta
              acción no se puede revertir
            </Typography>
          }
          open={confirmDialogOpen}
        />
      </>
    </Modal>
  )
}

export default UninstallAppModal
